import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Modal,
    Typography,
    Button,
    IconButton,
    TextField,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(6px)",
    },
    paperSmall: {
        backgroundColor: "#ffffff",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        padding: "32px",
        borderRadius: "16px",
        width: "480px",
        maxWidth: "90%",
        outline: "none",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "24px",
        border: "1px solid rgba(0,0,0,0.08)",
        position: "relative",
    },
    title: {
        fontFamily: "Outfit, Roboto, sans-serif",
        fontWeight: 700,
        color: "#212121",
        fontSize: "1.6rem",
    },
    subtitle: {
        fontFamily: "Outfit, Roboto, sans-serif",
        color: "#666",
        fontSize: "0.85rem",
        marginBottom: "10px",
    },
    formContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        marginTop: "10px",
    },
    inputField: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "&.Mui-focused fieldset": {
                borderColor: "#00577B",
            },
        },
        "& .MuiInputLabel-outlined.Mui-focused": {
            color: "#00577B",
        },
    },
    formActions: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        gap: "16px",
        marginTop: "12px",
    },
    btnCancel: {
        borderColor: "#d32f2f",
        color: "#d32f2f",
        fontWeight: 600,
        flex: 1,
        textTransform: "none",
        borderRadius: "8px",
        padding: "10px",
        "&:hover": {
            backgroundColor: "#ffebee",
            borderColor: "#c62828",
        },
    },
    btnSubmit: {
        background: "linear-gradient(45deg, #00577B 30%, #0087BE 90%)",
        color: "white",
        fontWeight: 600,
        flex: 1,
        textTransform: "none",
        borderRadius: "8px",
        padding: "10px",
        "&:hover": {
            background: "linear-gradient(45deg, #004663 30%, #006D9A 90%)",
        },
    },
    closeButtonTop: {
        position: "absolute",
        top: "12px",
        right: "12px",
        color: "#666",
    },
}));

export default function PaperCredentialsModal({ open, onClose, onSubmit }) {
    const classes = useStyles();
    const [paperCode, setPaperCode] = useState("");
    const [paperPasskey, setPaperPasskey] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!paperCode.trim() || !paperPasskey.trim()) {
            toast.error("Please fill in both fields.");
            return;
        }
        onSubmit({
            paperCode: paperCode.trim(),
            paperPasskey: paperPasskey.trim(),
        });
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.modal}
            disableBackdropClick
        >
            <div className={classes.paperSmall}>
                <IconButton
                    onClick={onClose}
                    className={classes.closeButtonTop}
                    size="small"
                    title="Close"
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h5" className={classes.title}>
                    Sync Question Paper
                </Typography>

                <Typography variant="body2" className={classes.subtitle}>
                    Enter Paper Code and Passkey to fetch questions
                </Typography>

                <form onSubmit={handleSubmit} className={classes.formContainer}>
                    <TextField
                        label="Paper Code"
                        variant="outlined"
                        value={paperCode}
                        onChange={(e) => setPaperCode(e.target.value)}
                        required
                        placeholder="e.g. 4001CJA102122060"
                        className={classes.inputField}
                        autoFocus
                    />
                    <TextField
                        label="Paper Passkey"
                        variant="outlined"
                        value={paperPasskey}
                        onChange={(e) => setPaperPasskey(e.target.value)}
                        required
                        placeholder="Enter passkey"
                        className={classes.inputField}
                    />
                    <div className={classes.formActions}>
                        <Button
                            variant="outlined"
                            className={classes.btnCancel}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            className={classes.btnSubmit}
                        >
                            Submit
                        </Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
